// Trumbowygを使用するのにグローバルスコープ(window)にjQueryの定義が必要
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery

